module.exports = __webpack_public_path__ + "static/staff-2-16f83d55aa675c2ad760f8626896678a.jpg";